import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByAssignment'
})

export class filterByAssignment implements PipeTransform {
    transform(items: any[], assigned: number): any {
        if(!items || assigned == null){
            return items;
        }
        return items.filter(item => item.professional_name == null)
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-byAssignment.pipe.ts